"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var public_api_1 = require("@l2p/public-api");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var useCalculatedBonus = function (data, currentCurrency, formState) {
    var _a, _b, _c, _d, _e, _f;
    var currentBonus = data === null || data === void 0 ? void 0 : data.find(function (b) { var _a; return b.id === ((_a = formState === null || formState === void 0 ? void 0 : formState.values) === null || _a === void 0 ? void 0 : _a['bonusId']); });
    var t = (0, next_intl_1.useTranslations)('translation');
    var bonusObj = {
        // cash: null,
        relative: null,
        freespins: null,
        amount: 0,
    };
    var maxBonusData = (_a = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.constraints) === null || _a === void 0 ? void 0 : _a.find(function (r) { return r.type === public_api_1.BonusConstraintType.MaxBonus; });
    var maxBonus = (_b = maxBonusData === null || maxBonusData === void 0 ? void 0 : maxBonusData.maxBonus) === null || _b === void 0 ? void 0 : _b.find(function (b) { return b.currency === currentCurrency; });
    var maxBonusAmount = maxBonus === null || maxBonus === void 0 ? void 0 : maxBonus.amount;
    var minDepositData = (_c = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.conditions) === null || _c === void 0 ? void 0 : _c.find(function (c) { return c.type === public_api_1.BonusConditionType.MinDepositAmount; });
    var minDeposit = (_d = minDepositData === null || minDepositData === void 0 ? void 0 : minDepositData.minDeposit) === null || _d === void 0 ? void 0 : _d.find(function (d) { return d.currency === currentCurrency; });
    var minDepositAmount = minDeposit === null || minDeposit === void 0 ? void 0 : minDeposit.amount;
    var relativePercentData = (_e = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _e === void 0 ? void 0 : _e.find(function (r) { return r.type === public_api_1.BonusRewardType.Relative; });
    var relativePercent = relativePercentData === null || relativePercentData === void 0 ? void 0 : relativePercentData.relativePercent;
    if (relativePercent && (formState.values['amount'] || '0')) {
        var maxBonusByPercent = (Number(formState.values['amount'] || '0') * relativePercent) / 100;
        var bonusAmount = maxBonusAmount && maxBonusByPercent > maxBonusAmount
            ? maxBonusAmount
            : maxBonusByPercent;
        bonusObj.relative = "".concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat(bonusAmount);
        bonusObj.amount = bonusAmount;
    }
    var freeRoundsCountData = (_f = currentBonus === null || currentBonus === void 0 ? void 0 : currentBonus.rewards) === null || _f === void 0 ? void 0 : _f.find(function (r) { return r.type === 'FREE_ROUNDS' || r.type === 'REPEATABLE_FREE_ROUNDS'; });
    var freeRoundsCount = freeRoundsCountData === null || freeRoundsCountData === void 0 ? void 0 : freeRoundsCountData.freeRoundsCount;
    if (Number(freeRoundsCount) > 0) {
        bonusObj.freespins = "".concat(freeRoundsCount, " ").concat(t('fs').toUpperCase());
    }
    return (0, react_1.useMemo)(function () {
        if (!bonusObj.freespins && !bonusObj.cash && !bonusObj.relative)
            return {
                bonus: "-",
                bonusAmount: 0,
                minDepositAmount: minDepositAmount,
            };
        return {
            bonus: "".concat(bonusObj.relative || '', " ").concat(bonusObj.freespins ? "+ ".concat(bonusObj.freespins) : ''),
            bonusAmount: bonusObj.amount,
            minDepositAmount: minDepositAmount,
        };
    }, [currentBonus, formState === null || formState === void 0 ? void 0 : formState.values, currentCurrency]);
};
exports.default = useCalculatedBonus;
